export default __webpack_public_path__ + "static/media/next.d13a5bca.svg";